import styled from 'styled-components'

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem;

  button {
    margin-right: 0;
  }

  .btn {
    width: auto;
  }
`
